/**
 * 顶栏右侧的状态：上课时长 + 网络质量。
 *
 * 老系统这两样都没有。「卡了」「听不清」在课堂上天天发生，
 * 而双方只能互相猜是谁的网络有问题 —— 这里给一个能直说的依据。
 */

import { useEffect, useState } from 'react'

import { useRoomStore } from '../stores/roomStore'

/** 上课时长。从进教室那一刻算起。 */
export function ClassTimer() {
  const [since] = useState(() => Date.now())
  const [now, setNow] = useState(since)

  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(t)
  }, [])

  const sec = Math.max(0, Math.floor((now - since) / 1000))
  const h = Math.floor(sec / 3600)
  const m = Math.floor((sec % 3600) / 60)
  const s = sec % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return (
    <span className="cr-timer mono" title="本次上课时长">
      {h > 0 ? `${pad(h)}:` : ''}
      {pad(m)}:{pad(s)}
    </span>
  )
}

/** 网络质量指示。只在有结论时显示，避免刚进门就闪一下。 */
export function NetIndicator() {
  const net = useRoomStore((s) => s.net)
  if (net.level === 'unknown') return null
  return (
    <span className={`cr-net net-${net.level}`} title={net.text}>
      <span className="net-bars" aria-hidden>
        <i /><i /><i />
      </span>
      {net.level === 'good' ? '网络良好' : net.level === 'fair' ? '网络一般' : '网络很差'}
    </span>
  )
}
